import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsModule } from '../utils/utils.module';
import { RouterModule } from '@angular/router';
import { BookListComponent } from './pages/book-list/book-list.component';
import { BookDetailsComponent } from './pages/book-details/book-details.component';
import { BookListItemComponent } from './components/book-list-item/book-list-item.component';
import { BookReaderComponent } from './pages/book-reader/book-reader.component';
import { WebBrowserComponent } from './components/web-browser/web-browser.component';
import { WebBrowserV2Component } from './components/web-browser-v2/web-browser-v2.component';
import { QuizComponent } from './components/quiz/quiz.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    BookListComponent,
    BookDetailsComponent,
    BookListItemComponent,
    BookReaderComponent,
    WebBrowserComponent,
    WebBrowserV2Component,
    QuizComponent
  ],
  imports: [
    CommonModule,
    UtilsModule,
    RouterModule,
    FormsModule
  ],
  exports: [
    BookListComponent,
    BookDetailsComponent,
    BookListItemComponent
  ]
})
export class BooksModule { }
